<script setup>
import { withQuery } from "ufo";
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Jakarta");

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Card";

const route = useRoute();
const router = useRouter();

const { data: dataQuery } = await useApi(
  withQuery("/cms/card/" + route.params.id, {
    method: "GET",
  }),
);
const data = dataQuery ? dataQuery.value?.data : [];

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/card",
  },
  {
    title: data.id,
    to: null,
  },
];

const matchings = [
  {
    title: "Exact match",
    value: 0,
  },
  {
    title: "Forward match",
    value: 1,
  },
  {
    title: "Backward match",
    value: 2,
  },
];

const cardTypes = [
  {
    title: "Normal",
    value: 0,
  },
];
const statuses = [
  {
    title: "Unused",
    value: 10,
  },
  {
    title: "Active",
    value: 20,
  },
  {
    title: "Suspicious",
    value: 30,
  },
  {
    title: "Invalidated",
    value: 31,
  },
  {
    title: "Discard",
    value: 41,
  },
];
console.log("data", data);
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">{{ pageTitle }} Detail</h4>
  <VCard border class="v-card-data" title="Card Information">
    <template #append>
      <div class="d-flex gap-4">
        <!--        <VBtn color="success">
                  <VIcon icon="tabler-lock-access-off" start />
                  Unissue
                </VBtn>-->
        <VBtn
          :to="{ path: '/admin/card/update/' + route.params.id }"
          block
          color="primary"
        >
          <VIcon icon="tabler-pencil" start />
          Edit {{ pageTitle }}
        </VBtn>
      </div>
    </template>
    <VTable class="text-no-wrap" density="compact">
      <tbody>
        <tr>
          <td>Card number</td>
          <td>{{ data.cardNumber }}</td>
        </tr>
        <tr>
          <td>Card new number</td>
          <td>{{ data.newCardNumber }}</td>
        </tr>
        <tr>
          <td>Card old number</td>
          <td>{{ data.oldCardNumber }}</td>
        </tr>
        <tr>
          <td>IC chip ID</td>
          <td>{{ data.cardChip }}</td>
        </tr>
        <tr>
          <td>Card mode</td>
          <td>{{ (data.cardMode = 2 ? "Online" : "Offline") }}</td>
        </tr>
        <tr>
          <td>Media type</td>
          <td>{{ data.mediaType }}</td>
        </tr>
        <tr>
          <td>Card type</td>
          <td>
            <AppSelect
              v-model="data.cardType"
              :items="cardTypes"
              class="v-select-print"
              readonly
            />
          </td>
        </tr>
        <tr v-show="data.cardMode == 2">
          <td>Holder ID</td>
          <td>{{ data.holderId }}</td>
        </tr>
        <tr>
          <td>Card balance</td>
          <td>{{ data.balance }}</td>
        </tr>
        <tr>
          <td>Status</td>
          <td>
            <AppSelect
              v-model="data.status"
              :items="statuses"
              class="v-select-print"
              readonly
            />
          </td>
        </tr>
        <tr>
          <td>Account status</td>
          <td>
            <AppSelect
              v-model="data.accountStatus"
              :items="statuses"
              class="v-select-print"
              readonly
            />
          </td>
        </tr>
        <tr>
          <td>Expiry date of money</td>
          <td>
            {{
              data.expired
                ? moment(data.expired, "DD/MM/YYYY").format("LL")
                : null
            }}
          </td>
        </tr>
        <tr>
          <td>Available point</td>
          <td>{{ (data, point) }}</td>
        </tr>
        <tr>
          <td>PIN</td>
          <td>{{ data.pin }}</td>
        </tr>
        <tr>
          <td>Phone number</td>
          <td></td>
        </tr>
        <tr>
          <td>SMS notification propriety</td>
          <td></td>
        </tr>
        <tr>
          <td>Email</td>
          <td></td>
        </tr>
        <tr>
          <td>Email notification propriety</td>
          <td></td>
        </tr>
        <tr>
          <td>Birth year</td>
          <td></td>
        </tr>
        <tr>
          <td>Gender</td>
          <td></td>
        </tr>
        <tr>
          <td>Residence code</td>
          <td></td>
        </tr>
        <tr>
          <td>Member ID</td>
          <td></td>
        </tr>
        <tr>
          <td>Registration date and time</td>
          <td></td>
        </tr>
        <tr>
          <td>Activation date and time</td>
          <td>
            {{ data.activeDate ? moment(data.activeDate).format("LL") : null }}
          </td>
        </tr>
        <tr>
          <td>Suspended date and time</td>
          <td></td>
        </tr>
        <tr>
          <td>Recovered date and time</td>
          <td></td>
        </tr>
        <tr>
          <td>Discard date and time</td>
          <td></td>
        </tr>
        <tr>
          <td>Last update</td>
          <td>
            {{ data.updatedAt ? moment(data.updatedAt).format("LL") : null }}
          </td>
        </tr>
        <tr>
          <td>Memo</td>
          <td></td>
        </tr>
      </tbody>
    </VTable>
    <div class="d-none">
      <VCardTitle>Holder Information</VCardTitle>
      <VTable class="text-no-wrap" density="compact">
        <tbody>
          <tr>
            <td>Verified type</td>
            <td></td>
          </tr>
          <tr>
            <td>Verified document ID</td>
            <td></td>
          </tr>
          <tr>
            <td>Number of card</td>
            <td></td>
          </tr>
          <tr>
            <td>Number of virtual card</td>
            <td></td>
          </tr>
          <tr>
            <td>KYC status</td>
            <td></td>
          </tr>
          <tr>
            <td>Status</td>
            <td></td>
          </tr>
          <tr>
            <td>Login</td>
            <td></td>
          </tr>
          <tr>
            <td>Family name</td>
            <td></td>
          </tr>
          <tr>
            <td>Middle name</td>
            <td></td>
          </tr>
          <tr>
            <td>Given name</td>
            <td></td>
          </tr>
          <tr>
            <td>Postal code</td>
            <td></td>
          </tr>
          <tr>
            <td>Region</td>
            <td></td>
          </tr>
          <tr>
            <td>Address</td>
            <td></td>
          </tr>
          <tr>
            <td>Building name etc.</td>
            <td></td>
          </tr>
          <tr>
            <td>Mobile number</td>
            <td></td>
          </tr>
          <tr>
            <td>Email address</td>
            <td></td>
          </tr>
          <tr>
            <td>Date of birth</td>
            <td></td>
          </tr>
          <tr>
            <td>Gender</td>
            <td></td>
          </tr>
          <tr>
            <td>Member rank</td>
            <td></td>
          </tr>
          <tr>
            <td>Memo</td>
            <td></td>
          </tr>
          <tr>
            <td>Last update</td>
            <td></td>
          </tr>
        </tbody>
      </VTable>
    </div>
  </VCard>
  <div class="mx-auto text-center">
    <VBtn
      :to="{ path: '/admin/card' }"
      class="mt-5 mx-auto text-center"
      color="secondary"
    >
      <VIcon icon="tabler-refresh" start />
      Back to {{ pageTitle }} List
    </VBtn>
  </div>
</template>
